import { Component, OnInit,ViewChild } from '@angular/core';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';

@Component({
  selector: 'app-gallary',
  templateUrl: './gallary.component.html',
  styleUrls: ['./gallary.component.css']
})
export class GallaryComponent implements OnInit {

  constructor(private domSanitizer: DomSanitizer) { }

  safeUrl: SafeUrl;
  youTubeVideoIds: string[] = [];
  //cameraImgUrl:string="testing";
  
  ngOnInit() {
    //this.safeUrl = this.domSanitizer.bypassSecurityTrustResourceUrl("https://www.youtube.com/embed/6Bzg4A-DxSM");
    this.youTubeVideoIds = this.getYouTubeVideoList();  

  //   let self=this;
  //   setInterval(function() {      
  //     self.cameraImgUrl = 'http://192.168.1.250/cgi-bin/snapshot.cgi?channel=1&subtype=0&' + Math.random();
  // }, 2000);

  }

  getSafeUrl(youTubeId: string): SafeUrl {
    return this.domSanitizer.bypassSecurityTrustResourceUrl("https://www.youtube.com/embed/" + youTubeId);
  }

  getYouTubeVideoList(): string[] {
    return [
      "bWQpQWl33TQ",
      "fKdN7jwTFvE",
      "Oe-1tSlLmcQ",
      "w6gOKKxC1r8",
      "N60UmVGFAfw",
      "urYK9TFUim4",
      "9vqTEnDYI-0",
      "cpmCCRQc4wg"
      
      // "ZBzjcRcB6kk",
      // "cF3tmq59X7I",
      // "-LnoXHxZ9Ig",
      // "ZzV2tuIhvzk",
      // "BdRPNNtDg90"
    ]
  }

}



// WEBPACK FOOTER //
// ./src/app/devotee-module/components/gallary/gallary.component.ts